<app-shared-engagement-table
  [engagementList]="engagementList"
  [isPoeDoc]="isPoeDoc"
  [prevDocumentType]="prevDocumentType"
  [loading]="loading"
  (refreshList)="initializePoeDocReviewList()"></app-shared-engagement-table>
